module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_rogaland_pos.dd85bd6f.png";